import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  width: 100%;

  @media (max-width: 900px) {
    height: 100%;
  }

  @media (max-width: 767px) {
    padding-top: 9px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const Header = styled.div`
  margin-bottom: 2.3em;

  @media (max-width: 900px) {
    padding-right: 2em;
  }

  @media (max-width: 767px) {
    margin-bottom: 0;
  }
`;

export const Title = styled.div`
  font-size: 32px;
  line-height: 1.4em;
  color: var(--carbone100);
  font-weight: 600;
  margin: 2px 0;

  @media (max-width: 767px) {
    font-size: 20px;
    margin: 11px 0 20px;
  }
`;

export const Breadcrumbs = styled.div`
  .icon_right {
    margin: 0 4px;
  }
`;

export const BreadcrumbItem = styled(Link)`
  font-size: 12px;
  color: var(--carbone70);

  .icon {
    fill: var(--carbone50);
    margin: 0 4px;
  }
`;

export const BreadcrumbLabel = styled.span`
  vertical-align: middle;
`;

export const Content = styled.div`
  display: flex;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const Photo = styled.div`
  background: #fff;
  border-radius: 4px;
  border: 1px solid var(--aluminium35);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  position: relative;
  padding: 20px;

  @media (max-width: 900px) {
    min-height: 0;
  }

  img {
    border-radius: 4px;
  }
`;

export const Details = styled.div`
  padding-left: 2vw;

  .dd {
    width: 100%;
    margin-top: -6px;
    margin-bottom: -5px;
  }

  @media (max-width: 900px) {
    padding-left: 0;
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;

export const Col = styled.div`
  width: 53%;

  @media (max-width: 900px) {
    width: auto;
  }
`;

export const ImgCol = styled.div`
  width: 47%;
  flex-basis: 400px;

  @media (max-width: 900px) {
    width: auto;
    flex-basis: 0;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;

export const Line = styled.div`
  margin-bottom: 22px;

  &:last-child {
    margin-bottom: 20px;
  }
`;

export const Capt = styled.div`
  font-size: 13px;
  line-height: 1.2em;
  color: var(--carbone70);
  margin-bottom: 10px;
`;

export const Producer = styled.div`
  color: var(--carbone100);

  .flag-icon {
    margin-right: 0.5rem;
  }
`;

export const Price = styled.div`
  font-size: 22px;
  font-weight: 700;
  line-height: 1.15em;
  color: var(--carbone100);
  margin-top: -2px;
`;

export const Hint = styled.div`
  font-size: 13px;
  line-height: 1em;
  font-weight: 600;
  color: var(--carbone50);
`;

export const Message = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: var(--blue120);
  display: flex;
  margin: 1.6em 0 -0.2em;
`;

export const Icon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--aluminium10);
  flex-shrink: 0;
  margin-right: 10px;
  font-size: 20px;
`;

export const Text = styled.p`
  font-size: 12px;
  line-height: 1.34em;
`;

export const NotAvailable = styled.div`
  color: var(--carbone70);
  font-size: 15px;
`;

export const ButtonsCont = styled.div`
  @media (max-width: 900px) {
    display: none;
  }
`;

export const Footer = styled.div`
  display: none;
  margin: 0 -20px -20px;

  @media (max-width: 900px) {
    display: flex;
  }

  @media (max-width: 767px) {
    margin-bottom: 0;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .btn,
  .btn-stroke {
    margin-right: 0;
    width: 50%;
    border-radius: 0;
  }
`;

export const InnerWrapper = styled.div`
  @media (max-width: 900px) {
    flex-grow: 1;
  }
`;

export const Form = styled.form`
  height: 100%;
  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
  }
`;

export const LabelsContainer = styled.div`
  position: absolute;
  top: 19px;
  left: 19px;

  @media (max-width: 767px) {
    left: 24px;
  }
`;

export const ReleaseForm = styled.div`
  margin-bottom: 22px;
`;

export const Wishlist = styled.span`
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #c7cfd9;
  border-radius: 44px;

  .icon {
    font-size: 1em;
    stroke-width: 1.2px;
    transition: var(--transition);
  }

  .icon_filled {
    fill: var(--theme-palette-brand-color);
    stroke: var(--theme-palette-brand-color);
  }

  &:hover .icon {
    stroke: var(--theme-palette-brand-color);
  }
`;

export const WishlistTitle = styled.span`
  font-size: 13px;
  line-height: 1.53em;
  color: var(--carbone70);
`;
